module.exports = __webpack_public_path__ + "a6d29177cc01ace49e6cbd5a3510d983.MP3";